/*
 * This is the same logic the backend uses
 * for what the current year is.
 *
 * This hook should only be used in the context of
 * registration, since we don't make a call to the backend
 * for obtaining current tax year stuff unless the user logs in.
 *
 * TODO: add checking the store value and then fallback to this value
 */
export const useCurrentTaxYear = (): number => {
  let currentYear = new Date().getFullYear();

  return currentYear - 1;
}
